export default __webpack_public_path__ + "static/media/loading.34946461.gif";